// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { ThemeContextProvider } from './contexts/themeContext';
import './i18n';
import './styles/styles.scss';

const children = (
	<ThemeContextProvider>
		<Router>
			{/* <React.StrictMode> */}
			<App />
			{/* </React.StrictMode> */}
		</Router>
	</ThemeContextProvider>
);

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
